import React, { useState } from 'react';
import { Switch, Typography, Card, CardContent, Divider, Chip } from '@mui/material';


const Notifications = ({notificationSettings, setNotificationSettings, isUserAdmin}) => {

    const handleToggle = (id) => {
        setNotificationSettings((prev) => ({ ...prev, [id]: {...prev[id], value: !prev[id].value} }));
    };

    const getSourceLabel = (source) => {
        return source === 'user' ? 'You' : 'Resident';
    };

    const getSourceColor = (source) => {
        return source === 'user' ? 'primary' : 'default';
    };


    return (
        <div className="max-w-3xl mx-auto p-6">
            <Typography variant="h5" className="mb-4 font-semibold text-gray-800">
                Email Notification Settings
            </Typography>
            <Card className="shadow-md mt-4">
                <CardContent>
                    {Object.keys(notificationSettings).map((key, index) => (
                        !isUserAdmin && notificationSettings[key].source !== "user" ? null :
                        <div key={key}>
                            <div className="flex justify-between items-start py-4">
                                <div>
                                    <div className="flex items-center gap-2">
                                        <Typography variant="subtitle1" className="font-medium text-gray-900">
                                            {notificationSettings[key].title}
                                        </Typography>
                                        <Chip
                                            size="small"
                                            label={getSourceLabel(notificationSettings[key].source)}
                                            color={getSourceColor(notificationSettings[key].source)}
                                            className="text-xs"
                                        />
                                    </div>
                                    <Typography variant="body2" className="text-gray-600">
                                        {notificationSettings[key].description}
                                    </Typography>
                                </div>
                                <Switch
                                    checked={notificationSettings[key].value}
                                    onChange={() => handleToggle(key)}
                                    color="primary"
                                />
                            </div>
                            {index < Object.keys(notificationSettings).length - 1 && <Divider />}
                        </div>
                    ))}
                </CardContent>
            </Card>
        </div>
    );
};

export default Notifications;
